import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const PersonPercentIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    {/* Person head and body only (cross removed) */}
    <path d="M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4M1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4" />
    {/* Percent symbol replacing the cross */}
    <circle cx="17.5" cy="8.5" r="1.3" />
    <line
      x1="21.9"
      y1="8.1"
      x2="17.1"
      y2="12.9"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="21.5" cy="12.5" r="1.3" />
  </SvgIcon>
);

export default PersonPercentIcon;
